import { createNode, el } from '@elemaudio/core'
import CompositeProps from '../types/CompositeProps'
import { EMPTY_PATH } from '../utils/AudioConstants'
import { SerializableAudioStem } from '../utils/CreateGraph'
import { tempoToIntervalMs, treeAdd } from '../utils/ElementaryUtils'
import { getClipVFSPath } from '../utils/GenerateClipAudioBuffer'

export interface AudioClipPlayerProps {
  stem: SerializableAudioStem
  clipsWithAudio: any[]
  index: string
  tempo: number
  repeat: any // TODO make a repeat type
  ppqn: number
  channel: number
  mode: string // TODO only allow 'offline' or 'core'
}

const AudioClipPlayerComposite = ({ props, children: [baseClock, resetClock] }: CompositeProps) => {
  const { clipsWithAudio, repeat, tempo, ppqn, channel }: AudioClipPlayerProps = props

  const clips = clipsWithAudio.map((clip) => {
    const audioDuration = clip.sampleMap.audioDuration
    if (audioDuration === 0) return 0

    const path = clip.isProcessing
      ? `${EMPTY_PATH}:${channel}` // if the FE is still processing the clip transforms, use the empty path
      : `${getClipVFSPath(clip, audioDuration, tempo)}:${channel}`
    const key = `clip:${clip.uniqueId}:channel:${channel}`

    const start: number = clip.startInComposition48n
    const end: number = clip.endInComposition48n

    const seq = [
      {
        value: 0,
        tickTime: start
      },
      { value: 1, tickTime: end }
    ]

    return el.table(
      {
        key: `${key}-sample`,
        path
      },
      el.sparseq(
        {
          key: `${key}-clipSeq`,
          seq: seq,
          loop: repeat.repeatSection ? [repeat.repeatStart, repeat.repeatEnd] : false,
          offset: ppqn,
          interpolate: 1,
          tickInterval: tempoToIntervalMs(tempo, 48) / 1000
        },
        baseClock,
        resetClock
      )
    )
  })
  return treeAdd(clips)
}

export default function AudioClipPlayer(props: AudioClipPlayerProps, baseClock, resetClock) {
  return createNode(AudioClipPlayerComposite, props, [baseClock, resetClock])
}
